/**
 * @generated SignedSource<<fca527afe9ca933ddd933757df0a7e99>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useFacilityInstructorNoun_facility$data = {
  readonly copyOverrides: {
    readonly instructor: {
      readonly plural: string;
      readonly singular: string;
    } | null | undefined;
  };
  readonly " $fragmentType": "useFacilityInstructorNoun_facility";
};
export type useFacilityInstructorNoun_facility$key = {
  readonly " $data"?: useFacilityInstructorNoun_facility$data;
  readonly " $fragmentSpreads": FragmentRefs<"useFacilityInstructorNoun_facility">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useFacilityInstructorNoun_facility",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "FacilityCopyOverrides",
      "kind": "LinkedField",
      "name": "copyOverrides",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "NounOverride",
          "kind": "LinkedField",
          "name": "instructor",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "plural",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "singular",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Facility",
  "abstractKey": null
};

(node as any).hash = "6a2b1271bc53e7d289bc5a37db794b92";

export default node;
